import { floorToTwoDecimals } from "@common/utils/numberUtils";
import { defaultTo } from "lodash";
import {IModel, InvoiceSalesItemTraitModel, Model} from ".";
import { DiscountItemTypes } from "./Enums";

export interface IInvoiceSalesItemModel extends IModel {
    salesItemId: number;
    salesItemOptionId: number;
    invoiceId: number;
    invoiceSalesItemId: number;
    parentInvoiceSalesItemId: number | undefined;
    salesItemName: string;
    salesItemFullName: string;
    salesItemOptionName: string;
    salesItemOptionDisplayName: string;
    quantity: number;
    dispensingFee: number | undefined;
    salesItemPrice: number;
    rebateAmount: number | undefined;
    postRebatePrice: number | undefined;
    discountAmount: number | undefined;
    invoicePrice: number | undefined;
    invoiceUnitPrice: number | undefined;
    estimateQuantityLow: number | undefined;
    estimateQuantityHigh: number | undefined;
    salesItemOptionMinimumQuantity: number;
    salesItemOptionMaximumQuantity: number;
    salesItemOptionAllowUserEnteredPrice: boolean;
    wasDeclinedByClient: boolean;
    wasDeclinedByVeterinarian: boolean;
    salesItemOptionBusinessLineSKU: string | undefined;
    isInPackage: boolean;
    salesPackageId: number | undefined;
    salesPackageName: string | undefined;
    salesItemSalesItemTypeId: number;
    invoiceSalesItemTraits: InvoiceSalesItemTraitModel[];
}

export class  InvoiceSalesItemModel extends Model implements IInvoiceSalesItemModel {
    invoiceId: number;
    invoiceSalesItemId: number;
    salesItemId: number;
    salesItemOptionId: number;
    parentInvoiceSalesItemId: number | undefined;
    salesItemName: string;
    salesItemFullName: string;
    salesItemOptionName: string;
    salesItemOptionDisplayName: string;
    quantity: number;
    dispensingFee: number | undefined;
    salesItemPrice: number;
    rebateAmount: number | undefined;
    postRebatePrice: number | undefined;
    discountAmount: number | undefined;
    invoicePrice: number | undefined;
    invoiceUnitPrice: number | undefined;
    estimateQuantityLow: number | undefined;
    estimateQuantityHigh: number | undefined;
    salesItemOptionMinimumQuantity: number;
    salesItemOptionMaximumQuantity: number;
    salesItemOptionAllowUserEnteredPrice: boolean;
    wasDeclinedByClient: boolean;
    wasDeclinedByVeterinarian: boolean;
    salesItemOptionBusinessLineSKU: string | undefined;
    isInPackage: boolean;
    salesPackageId: number | undefined;
    salesPackageName: string | undefined;
    salesItemSalesItemTypeId: number;
    invoiceSalesItemTraits: InvoiceSalesItemTraitModel[];

    constructor(params: IInvoiceSalesItemModel) {
        super(params);
        this.invoiceId = defaultTo(params.invoiceId, 0);
        this.invoiceSalesItemId = defaultTo(params.invoiceSalesItemId, 0);
        this.salesItemId = defaultTo(params.salesItemId, 0);
        this.salesItemOptionId = defaultTo(params.salesItemOptionId, 0);
        this.parentInvoiceSalesItemId = params.parentInvoiceSalesItemId;
        this.salesItemName = params.salesItemName;
        this.salesItemFullName = params.salesItemFullName;
        this.salesItemOptionName = params.salesItemOptionName;
        this.salesItemOptionDisplayName = params.salesItemOptionDisplayName;
        this.quantity = params.quantity;
        this.dispensingFee = params.dispensingFee;
        this.salesItemPrice = defaultTo(params.salesItemPrice, 0);
        this.rebateAmount = params.rebateAmount;
        this.postRebatePrice = params.postRebatePrice;
        this.discountAmount = params.discountAmount;
        this.invoicePrice = params.invoicePrice;
        this.invoiceUnitPrice = params.invoiceUnitPrice;
        this.estimateQuantityLow = params.estimateQuantityLow;
        this.estimateQuantityHigh = params.estimateQuantityHigh;
        this.salesItemOptionMinimumQuantity = defaultTo(params.salesItemOptionMinimumQuantity, 0);
        this.salesItemOptionMaximumQuantity = defaultTo(params.salesItemOptionMaximumQuantity, 0);
        this.salesItemOptionAllowUserEnteredPrice = defaultTo(params.salesItemOptionAllowUserEnteredPrice, false);
        this.wasDeclinedByClient = defaultTo(params.wasDeclinedByClient, false);
        this.wasDeclinedByVeterinarian = defaultTo(params.wasDeclinedByVeterinarian, false);
        this.salesItemOptionBusinessLineSKU = defaultTo(params.salesItemOptionBusinessLineSKU, undefined);
        this.isInPackage = defaultTo(params.isInPackage, false)
        this.salesPackageId = params.salesPackageId;
        this.salesPackageName = params.salesPackageName;
        this.salesItemSalesItemTypeId = defaultTo(params.salesItemSalesItemTypeId, 0);
        this.invoiceSalesItemTraits = defaultTo(params.invoiceSalesItemTraits, []);
    }
    getBarcodePrice(scalar: number) {
        const handledScalar = !Number.isNaN(scalar) ? scalar : 1;
        const price = (this.invoicePrice ?? this.salesItemPrice);
        return floorToTwoDecimals(price * handledScalar);
    }
    IsDiscountItem = () => DiscountItemTypes.includes(this.salesItemSalesItemTypeId);
}
